var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyBetsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:current;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.29,94.61v-4h3.37V62.89H88.29v-4h3.37V43.62H83.52a11.27,11.27,0,1,1-22.53,0H52.85V110H61a11.27,11.27,0,1,1,22.53,0h8.14V94.61Zm-32.08,0H52.85v-4h3.36Zm0-31.72H52.85v-4h3.36Zm19.25-4h6.42v4H75.46Zm-12.83,0h6.42v4H62.63Zm6.42,35.76H62.63v-4h6.42Zm12.83,0H75.46v-4h6.42ZM77.21,78.5,80,86.05l-7.3-3.65-7.29,3.65,2.83-7.55L63,73.89h7l2.73-7.29,2.74,7.29h7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.69,110v1.45l12-63.67-8-1.5a11.27,11.27,0,0,1-4,6.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.25,50.85A7.22,7.22,0,0,0,78,48a11.06,11.06,0,0,1-.47-5.87l-8-1.51-1.65,8.77A7.12,7.12,0,0,0,72.25,50.85Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBetsWhite);
export default __webpack_public_path__ + "static/media/my-bets-white.70e109893d493381d392faef59dc7e15.svg";
export { ForwardRef as ReactComponent };